import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const betPropTypes = PropTypes.shape({
    betType: PropTypes.string.isRequired,
    receiptId: PropTypes.string.isRequired,
    returns: PropTypes.number,
    stake: PropTypes.number.isRequired,
    totalStake: PropTypes.number.isRequired,
    timeBetPlaced: PropTypes.string.isRequired,
    win: PropTypes.bool,
    selections: PropTypes.arrayOf(PropTypes.shape({
        eachWay: PropTypes.bool.isRequired,
        eventName: PropTypes.string.isRequired,
        odd: PropTypes.string.isRequired,
        selectionName: PropTypes.string.isRequired,
    })),
});



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/accountPage/components/betHistory/BetPropTypes.js